import {NavigationGuardNext, RouteLocationNormalizedGeneric, RouteRecordRaw} from "vue-router";
import HeaderView from "@/views/share/HeaderView.vue";
import LayoutView from "@/views/share/LayoutView.vue";
import {session} from "@/model/session";
import {message} from "ant-design-vue";

export default <Array<RouteRecordRaw>>[
    {
        path: '/account',
        name: '',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: '',
                name: 'account',
                meta: {auth: true},
                components: {
                    default: () => import(/* webpackChunkName: "account" */ './AccountPage.vue'),
                    header: HeaderView
                },
            },
            {
                path: 'wallet',
                name: 'wallet',
                meta: {auth: true},
                components: {
                    default: () => import(/* webpackChunkName: "wallet" */ './WalletPage.vue'),
                    header: HeaderView
                },
            },
            {
                path: 'merchant',
                name: 'merchant',
                meta: {auth: true},
                beforeEnter: (to, from, next) => {
                    if (session.agent) {
                        to.meta.merchant = session.agent.wechatMerchant;
                        next()
                    } else {
                        next('/login');
                    }
                },
                components: {
                    default: () => import(/* webpackChunkName: "merchant" */ './MerchantPage.vue'),
                    header: HeaderView
                },
            },
            {
                path: 'merchant/preview/applyment',
                meta: {auth: true},
                beforeEnter: (to, from, next) => {
                    if (typeof to.query.business_code != 'string' || !/^[a-zA-Z0-9_-]{22}$/.test(to.query.business_code)) {
                        next({name: 'merchant'})
                        message.warn('无效单号')
                    } else {
                        const a = session.agent?.wechatMerchant.applyment(to.query.business_code)
                        if (!a) {
                            next({name: 'merchant'})
                            message.warn('查无此单号')
                        }else {
                            a.syncSteps()
                            to.meta.applyment = a
                            next()
                        }
                    }
                },
                components: {
                    default: () => import(/* webpackChunkName: "merchant_preview_applyment" */ './MerchantPreviewApplymentPage.vue'),
                    header: HeaderView
                },
            },
            {
                path: 'merchant/applyment/:business_code',
                meta: {auth: true},
                components: {
                    default: () => import(/* webpackChunkName: "merchant_applyment" */ './MerchantApplymentPage.vue'),
                    header: HeaderView
                },
                beforeEnter: applymentGuard,
                children: [
                    {
                        path: '',
                        name: 'merchant_applyment',
                        meta: {auth: true},
                        beforeEnter: applymentGuard,
                        component: () => import(/* webpackChunkName: "merchant_ma_prepare" */  './applyment/MAPrepare.vue'),
                    },
                    {
                        path: 'entity',
                        meta: {auth: true},
                        beforeEnter: applymentGuard,
                        component: () => import(/* webpackChunkName: "merchant_ma_entity" */  './applyment/MAEntity.vue'),
                    },
                    {
                        path: 'business',
                        meta: {auth: true},
                        beforeEnter: applymentGuard,
                        component: () => import(/* webpackChunkName: "merchant_ma_business" */  './applyment/MABusiness.vue'),
                    },
                    {
                        path: 'payment',
                        meta: {auth: true},
                        beforeEnter: applymentGuard,
                        component: () => import(/* webpackChunkName: "merchant_ma_payment" */  './applyment/MAPayment.vue'),
                    },
                ]
            }
        ]
    },
]

function applymentGuard(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric, next: NavigationGuardNext) {
    if (typeof to.params.business_code != 'string' || !/^[a-zA-Z0-9_-]{22}$/.test(to.params.business_code)) {
        next({name: 'merchant'})
        message.warn('无效单号')
    } else {
        const a = session.agent?.wechatMerchant.applyment(to.params.business_code)
        if (!a) {
            message.warn('查无此单号')
            next({name: 'merchant'})
        } else {
            a.syncSteps()
            to.meta.applyment = a
            next()
        }
    }
}
